const GENRES = [
	"adventure",
	"classics",
	"comic book",
	"mystery",
	"fantasy",
	"historical fiction",
	"horror",
	"literary fiction",
	"romance",
	"science fiction",
	"short stories",
	"suspense",
	"non fiction",
	"history",
	"memoir",
	"poetry",
	"self help",
];

export default GENRES;
